var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPNavEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 0.666504C6.6265 0.666504 0.666504 6.6265 0.666504 13.9998C0.666504 21.3732 6.6265 27.3332 13.9998 27.3332C21.3732 27.3332 27.3332 21.3732 27.3332 13.9998C27.3332 6.6265 21.3732 0.666504 13.9998 0.666504ZM18.1332 7.4265C18.3198 7.4265 18.5065 7.49317 18.6665 7.63984L20.3598 9.33317C20.6665 9.6265 20.6665 10.0932 20.3598 10.3732L19.0265 11.7065L16.2932 8.97317L17.6265 7.63984C17.7598 7.49317 17.9465 7.4265 18.1332 7.4265ZM15.5065 9.7465L18.2532 12.4932L10.1732 20.5732H7.4265V17.8265L15.5065 9.7465Z",
    fill: "#4E26A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPNavEdit);
export default __webpack_public_path__ + "static/media/p_nav_edit.2a99db4b4a57bc0172ebc8d58a0c25cc.svg";
export { ForwardRef as ReactComponent };